import React from 'react';
import { FormField } from '../../../components/Form/FormField';
import { Button } from '../../../components/Button/Button';
import '../Form.css';

const RequestContact: React.FC = () => {
  return (
    <div className="request-contact">
      <div className="main">
        <div className="header">
          <h2>Request a contact</h2>
          <p>
            <b>
                Register your data and you will be contacted as soon as possible
            </b>
          </p>
        </div>
        
        <form className="contact-form">
          <div className="inputs">
            <div className="author-data">
              <FormField type="input" label="First name" data="First name" placeholder="First name..." />
              <FormField type="input" label="Last name" data="Last name" placeholder="Last name..." />
            </div>
            
            <FormField type="input" label="Email" data="Email" placeholder="Email..." />
            
            <FormField type="input" label="Phone Number" data="Phone Number" placeholder="Phone Number..." />
          </div>
          
          <Button variant="primary" label="Request" href="#"/>
        </form>
      </div>
    </div>
  );
};

export default RequestContact;